export const CalculatorConstants = {
    M18: 16.0383,
    N18: 36.2571,
    I37: {
        15: 34.4030,
        30: 44.0842,
        50: 56.9924,
    },
    J37: {
        15: 11.4559,
        30: 15.5746,
        50: 21.0663,
    },
    P18: 14.5011,
    Q18: 77.7311,
    O18: 5.0951,
    R18: 43.8920,
    K37: 0
}
